import { ConstService } from './../Const/const.service';
import { GetUserCompanyInfoResult } from 'src/app/Models/Company/get-user-company-info-result';
import { AppStateService } from '../AppState/app-state.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap, map, delay, retryWhen, scan, debounceTime } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { GetCompanyInfoResult } from 'src/app/Models/Account/get-company-info-result';
import { CompaniesByUserResult } from 'src/app/Models/Empresa/empresaModel';
import Rutas from 'src/app/Models/Base/rutas';
import { NavigationExtras } from '@angular/router';
import GetAccessOnboardingCompanyResult from 'src/app/Models/Company/get-access-onboarding-result';

export class CompanyService {
  private readonly path: string = 'company';

  constructor(private appState: AppStateService) { }

  GetList() {
    let url = `${ConstService.URLApi}/${this.path}/GetCompaniesByUser`;
    let params = new HttpParams()
      .set('itemsPerPage', this.appState.folder.itemsPerPage.toString())
      .set('pageNumber', this.appState.folder.page.toString());

    if (this.appState.folder.filter && !!this.appState.folder.filter.length) {
      params = params.append('companyName', this.appState.folder.filter);
    }
    return this.appState.http.get<CompaniesByUserResult>(url, { params }).pipe(
      map((c) => ({ ...c, companyList: c.companyList.slice(0, 4) })),
      tap((res) => {
        if (res.success) {

          this.appState.GetListcompany = res;
          this.appState.OneCompany = res.companyList.length === 1 ? true : false;
          this.appState.folder.totalItems = res.totalItems;
        } else throw res.message;
      }),
      catchError((err) => {
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );

        return throwError(err);
      })
    );
  }

  /**
   * GetUserCompanyInfo
   */
  public GetUserCompanyInfo() {
    this.appState.ExpirationBanner = '';
    const url = `${ConstService.URLApi}/${this.path}/GetUserCompanyInfo`;
    return this.appState.http.get<GetUserCompanyInfoResult>(url)
      .pipe(
        map(c => ({ 
          ...c, 
          name: c.name || 'Hola'
        })),
        tap((c) => {
          if (c.success) {
            //muestra banner para re direccion de onboarding
            this.appState.estadoOnboarding = c.onboardingStatus;
            this.appState.UserCompanyInfo.next(c);
          } 
          else {
            const navigationExtras: NavigationExtras = { state: { token: '-' } };
            this.appState.router.navigateByUrl(Rutas.ASSOCIATION, { state: navigationExtras });
          }
        })
      );
  }

  public GetCompanyAccessOnboarding(){
    const url = `${ConstService.URLApi}/${this.path}/CompanyAccessOnboading`;
    return this.appState.http.get<GetAccessOnboardingCompanyResult>(url)
    .pipe(
      tap(({success, message, onboardingStatus}) =>{
        if(!success){
          throw new Error(message)
        }
        // estadoOnboarding se setea desde GetUserCompanyInfo
      })
      , catchError(error =>{
        return of<GetAccessOnboardingCompanyResult>({ success: false, message: error, urlAccess: '', onboardingStatus: 0 })
      })
    )
  }

  public GetUrlEmbedNews(): Observable<{
    success: boolean;
    url: string | null;
  }> {
    return this.appState.UserCompanyInfo.asObservable()
      .pipe(
        delay(1000)
        , debounceTime(1000)
        , tap(({ email, name, pais, expirationDate }) => {
          if (!email && !name && !pais && !expirationDate) {
            throw new Error('Error')
          }
        })
        , map(({ subscriptionType, pais, name, email }) => ({ success: true, url: `${ConstService.beamerHost}&force_filter=erp;${subscriptionType};${pais}&custom_user_id=${ConstService.ID_USER}&firstname=${name}&email=${email}` }))
        , catchError((err) => of({ success: false, url: null }))
        , retryWhen(err => {
          return err.pipe(
            delay(1500),
            scan((retryCount) => {
              if (retryCount < 10) {
                throw new Error('Error')
              }
              else {
                retryCount++
              }
              return retryCount
            }, 0)
          )
        }),
      )
  }

  public DeleteCompanyForUser(company: string, ClientId: string) {
    let url = `${ConstService.URLApi}/Company/DeleteCompanyForUser`;
    let params = new HttpParams()
      .set('companyID', company)
      .set('clientID', ClientId);

    return this.appState.http
      .delete<GetCompanyInfoResult>(url, { params })
      .pipe(
        tap((res) => {
          if (res.success) {
            this.GetListEnterpriseManager().subscribe();
          } else throw res.message;
        }),
        catchError((err) => {
          this.appState.showMiniMessage(
            err || 'Ocurrio un error interno.',
            'error'
          );
          return throwError(err);
        })
      );
  }

  GetListEnterpriseManager(_filter?: string, _itemsPerPage?: number, _page?: number) {
    //se valida si la peticion proviene del modal para activar o desactivar loading global
    if (!_filter && !_itemsPerPage && !_page) {
      this.appState.loading = true;
    }
    let url = `${ConstService.URLApi}/Company/GetCompaniesByUser`;
    let { itemsPerPage, filter, page } = this.appState.folder;
    if (_filter && !!_filter.length) {
      filter = _filter;
    }
    if (_page) {
      page = _page;
    }
    if (_itemsPerPage) {
      itemsPerPage = itemsPerPage;
    }
    let params = new HttpParams()
      .set('itemsPerPage', itemsPerPage)
      .set('pageNumber', page);
    if (filter && !!filter.length) {
      params = params.append('companyName', filter);
    }
    return this.appState.http.get<CompaniesByUserResult>(url, { params }).pipe(
      map(res => filter && !res.success && /no se encontr[oó] ninguna empresa/i.test(res.message || '')
        ? { ...res, success: true, companyList: [], totalItems: 0 }
        : res),
      tap((res) => {
        if (res.success) {
          this.appState.GetListcompany = res;
          this.appState.folder.totalItems = res.totalItems;
          this.appState.loading = false;
        }
        else {
          throw res.message;
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }
}
